import { useRef } from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';
import { useQuery } from '@tanstack/react-query';
import { getTicketingLanguageSettings } from './lib/configuration';
import { setLanguage, setUserOverrides } from './locales';

export const TicketingLanguageProvider = ({ children }) => {
    const appliedRef = useRef(false);
    const { data: langSettings, isLoading, isSuccess } = useQuery({
        queryKey: ['ticketingLanguageSettings'],
        queryFn: getTicketingLanguageSettings,
    });

    if (isSuccess && !appliedRef.current) {
        if (langSettings && langSettings.selected_language) {
            setLanguage(langSettings.selected_language);
        }
        if (langSettings && langSettings.overrides) {
            setUserOverrides(langSettings.overrides, langSettings.selected_language);
        }
        appliedRef.current = true;
    }

    if (isLoading || !appliedRef.current) {
        return (
            <Dimmer active inverted page>
                <Loader size="large" content="Loading..." />
            </Dimmer>
        );
    }

    return children;
};

export default TicketingLanguageProvider;
